<template>
  <d-container fluid>
    <DocumentsPopup v-if="$store.state.popups.showDocumentsMembersPopupGeneral"
                    v-on:close="$store.commit('closeDocumentsMembersPopupFunc')"
                    :record-id="$store.state.popups.documentMembersPopupRecordIdGeneral"
                    :record-type="constants.recordType.Members"
    ></DocumentsPopup>

    <NotesPopup v-if="$store.state.popups.showNotesMembersPopupGeneral"
                v-on:close="$store.commit('closeNotesMembersPopupFunc')"
                :record-id="$store.state.popups.notesPopupMembersRecordIdGeneral"
                :record-type="constants.recordType.Members"
    ></NotesPopup>
    <ActivityPopup v-if="$store.state.popups.showActivityMembersPopupGeneral"
                   v-on:close="$store.commit('closeActivityMembersPopupFunc')"
                   :member-id="$store.state.popups.activityPopupMembersRecordIdGeneral"
    ></ActivityPopup>
    <TasksPopup v-if="$store.state.popups.showTasksMembersPopupGeneral"
                v-on:close="$store.commit('closeTasksMembersPopupGeneralFunc')"
                :record-id="$store.state.popups.tasksPopupMembersRecordIdGeneral"
                :record-type="constants.recordType.Members"
    ></TasksPopup>
    <EntriesPopup v-if="$store.state.popups.showEntriesMemberPopupGeneral"
                  v-on:close="$store.commit('closeEntriesMembersPopupGeneralFunc')"
                  :record-id="$store.state.popups.entrieMemberRecordIdGeneral"
                  :record-member-obj="$store.state.popups.entrieMemberObjectGeneral"
    ></EntriesPopup>
    <MemberEntryHubBootstrap />
    <MemberEntryPopup />
    <WhatsNewReleaseDrawer />
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems"/>

      <d-col class="main-content offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">
        <div class="flex-container-layout">
          <div>
            <!-- Main Navbar -->
            <main-navbar/>

            <!-- Content -->
            <div class="parent-container">
              <slot/>
            </div>
          </div>
          <!-- Main Footer -->
          <main-footer :copyright="`Powered by PTS`"/>
        </div>
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';

import constants from '@/utils/constants';
// Main layout components
import MainNavbar from '@/components/layout/MainNavbar/MainNavbar.vue';
import MainSidebar from '@/components/layout/MainSidebar/MainSidebar.vue';
import MainFooter from '@/components/layout/MainFooter/MainFooter.vue';
import TasksPopup from '@/components/General/Tasks/TasksPopup';
import NotesPopup from '@/components/General/Notes/NotesPopup';
import ActivityPopup from '@/components/General/Member/ActivityPopup';
import DocumentsPopup from '@/components/General/Documents/DocumentsPopup';
import EntriesPopup from '@/components/General/Entries/EntriesPopup';
import MemberEntryHubBootstrap from '@/components/General/MemberEntryHub/MemberEntryHubBootstrap';
import MemberEntryPopup from '@/components/General/MemberEntryHub/MemberEntryPopup';
import WhatsNewReleaseDrawer from '@/components/WhatsNew/WhatsNewReleaseDrawer.vue';

export default {
  name: 'analytics',
  components: {
    EntriesPopup,
    DocumentsPopup,
    NotesPopup,
    ActivityPopup,
    TasksPopup,
    MainNavbar,
    MainSidebar,
    MainFooter,
    MemberEntryHubBootstrap,
    MemberEntryPopup,
    WhatsNewReleaseDrawer,
  },
  data() {
    return {
      constants,
      sidebarItems: getSidebarItems(),
    };
  },
};
</script>
<style >
.main-content {
  background: linear-gradient(135deg, #f7fbff 0%, #eef7ff 45%, #e7f4fb 100%);
}

.flex-container-layout {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: 100vh;
}
.parent-container {
  position: relative;
  padding: 10px;
}
</style>
